import { render, staticRenderFns } from "./updHsft2.vue?vue&type=template&id=23caca6c&scoped=true"
import script from "./updHsft2.vue?vue&type=script&lang=js"
export * from "./updHsft2.vue?vue&type=script&lang=js"
import style0 from "./updHsft2.vue?vue&type=style&index=0&id=23caca6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23caca6c",
  null
  
)

export default component.exports